import { Locale } from 'modules/i18n';

export const chainsListTranslation = {
  [Locale.en]: {
    name: 'Name',
    requests: 'Requests',
    requestsTimeframe: 'Requests ({timeframeValue})',
    projects: 'Projects',
  },
};
